import { useEffect, useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Table } from "react-bootstrap";
import { getGradeInt, GradeLevelOptions, GradeOptions } from "../../../../../../_helpers/Helpers";
import { useGradeAndSectionReportUIContext } from "../GradeAndSectionReportUIContext";

export function GroupButtonsTable() {
  // Grade And Section Report UI Context
  const gradeAndSectionReportUIContext = useGradeAndSectionReportUIContext();
  const gradeAndSectionReportUIProps = useMemo(() => {
    return {
      columns: gradeAndSectionReportUIContext.columns,
      setData: gradeAndSectionReportUIContext.setData,
      gradeStyle: gradeAndSectionReportUIContext.gradeStyle,
      setGradeStyle: gradeAndSectionReportUIContext.setGradeStyle,
      gradeLevelStyle: gradeAndSectionReportUIContext.gradeLevelStyle,
      setGradeLevelStyle: gradeAndSectionReportUIContext.setGradeLevelStyle,
      queryParams: gradeAndSectionReportUIContext.queryParams
    };
  }, [gradeAndSectionReportUIContext]);

  // Getting curret state of Grade And Section Report from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.gradeAndSectionReport }),
    shallowEqual
  );
  const { entities } = currentState;

  useEffect(() => {
    if (gradeAndSectionReportUIProps.gradeLevelStyle === "light") setGroupedTable("gradeLevelName");
    else if (gradeAndSectionReportUIProps.gradeStyle === "light") setGroupedTable("grade");
    else gradeAndSectionReportUIProps.setData(entities ?? []);
    return () => setHidden(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entities]);  

  let groupedEntities = [];

  /** */
  const setGroupedTable = dataField => {
    if (dataField === "gradeLevelName") {
      setHidden(true);
    
      if (gradeAndSectionReportUIProps.queryParams.sortField === "grade") {
        const gradeLevels = [...new Set(entities.map(entity => entity.gradeLevel))];
        gradeLevels.forEach(grade => setLevelEntities(grade));

      } else {
        GradeLevelOptions.map(option => option.value).forEach(value => setLevelEntities(value));
      }

    } else if (dataField === "grade") {
      setHidden(false);
      
      if (gradeAndSectionReportUIProps.queryParams.sortField === "gradeLevelName" || gradeAndSectionReportUIProps.queryParams.sortField === "grade") {
        const grades = [...new Set(entities.map(entity => entity.grade))];
        grades.forEach(grade => setGradeEntities(grade));

      } else {
        GradeOptions.map(option => option.value).forEach(value => setGradeEntities(value));
      }    
    }

    gradeAndSectionReportUIProps.setData(groupedEntities);
  } 

  /** */
  const setHidden = value => gradeAndSectionReportUIProps.columns.find(column => column.dataField === "gradeLevelName").hidden = value;

  /** */
  const setLevelEntities = level => {
    const levelEntities = entities.filter(entity => entity.gradeLevel === level);

    if (levelEntities.length > 0) {
      groupedEntities.push({
        id: level,
        grade: GradeLevelOptions.find(option => option.value === level).label,
        name: "",
        capacity: levelEntities.reduce((sum, item) => sum + item.capacity, 0),
        maleStudentCount: levelEntities.reduce((sum, item) => sum + item.maleStudentCount, 0),
        femaleStudentCount: levelEntities.reduce((sum, item) => sum + item.femaleStudentCount, 0),
        reRegistratedStudentCount: levelEntities.reduce((sum, item) => sum + item.reRegistratedStudentCount, 0),
        newRegistratedStudentCount: levelEntities.reduce((sum, item) => sum + item.newRegistratedStudentCount, 0),
        totalStudentCount: levelEntities.reduce((sum, item) => sum + item.totalStudentCount, 0)
      });
    }

    groupedEntities = groupedEntities.concat(levelEntities);
  }

  /** */
  const setGradeEntities = grade => {
    const gradeEntities = entities.filter(entity => entity.grade === grade);

    if (gradeEntities.length > 0) {
      groupedEntities.push({
        id: getGradeInt(grade),
        gradeLevelName: gradeEntities[0].gradeLevelName,
        grade: grade,
        name: "",
        capacity: gradeEntities.reduce((sum, item) => sum + item.capacity, 0),
        maleStudentCount: gradeEntities.reduce((sum, item) => sum + item.maleStudentCount, 0),
        femaleStudentCount: gradeEntities.reduce((sum, item) => sum + item.femaleStudentCount, 0),
        reRegistratedStudentCount: gradeEntities.reduce((sum, item) => sum + item.reRegistratedStudentCount, 0),
        newRegistratedStudentCount: gradeEntities.reduce((sum, item) => sum + item.newRegistratedStudentCount, 0),
        totalStudentCount: gradeEntities.reduce((sum, item) => sum + item.totalStudentCount, 0)
      });
    }

    groupedEntities = groupedEntities.concat(gradeEntities);
  }

  /** */
  const onGradeLevelButtonClick = () => {
    gradeAndSectionReportUIProps.setGradeStyle("success");

    if (gradeAndSectionReportUIProps.gradeLevelStyle === "success") {
      gradeAndSectionReportUIProps.setGradeLevelStyle("light");
      setGroupedTable("gradeLevelName");
    
    } else if (gradeAndSectionReportUIProps.gradeLevelStyle === "light") {
      setHidden(false);
      gradeAndSectionReportUIProps.setGradeLevelStyle("success");
      gradeAndSectionReportUIProps.setData(entities);
    }
  }

  /** */
  const onGradeButtonClick = () => {
    gradeAndSectionReportUIProps.setGradeLevelStyle("success");

    if (gradeAndSectionReportUIProps.gradeStyle === "success") {
      gradeAndSectionReportUIProps.setGradeStyle("light");
      setGroupedTable("grade");
    
    } else if (gradeAndSectionReportUIProps.gradeStyle === "light") {
      gradeAndSectionReportUIProps.setGradeStyle("success");
      gradeAndSectionReportUIProps.setData(entities);
    }
  }
  
  return (
    <div className="mt-5">
      <Table hover>
        <tbody>
          <tr>
            <td style={{ width: "150px" }}>
              <button
                type="button"
                className={`btn btn-sm btn-${gradeAndSectionReportUIProps.gradeLevelStyle}`}
                onClick={onGradeLevelButtonClick}
              >
                Sınıf Düzeyi
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${gradeAndSectionReportUIProps.gradeStyle}`}
                onClick={onGradeButtonClick}
              >
                Sınıf
              </button>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}